'use client'

import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import * as React from 'react'

import { GridSection } from '@/components/marketing/fragments/grid-section'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from '@/components/ui/accordion'
import { Component } from '@/components/ui/etheral-shadow'
import { AppInfo } from '@/constants/app-info'

const DATA = [
  {
    question: msg`What is ${AppInfo.APP_NAME} and what makes it special?`,
    answer: msg`${AppInfo.APP_NAME} is a platform leveraging blockchain, AI, and Web3 technologies to build smart, transparent, and user-friendly digital ecosystems. Its goal is to enable individual users to access new technologies in a simple, secure, and convenient way.`
  },
  {
    question: msg`What can I use this platform for?`,
    answer: msg`You can use it to store digital assets, trace product origins, manage medical records, identify real estate, participate in cross-chain transactions, or simply explore decentralized applications within the ecosystem.`
  },
  {
    question: msg`Is my data safe?`,
    answer: msg`Yes. All data is protected by blockchain technology, where every action is transparently recorded and immutable. Additionally, the system uses modern encryption and does not store personal information centrally.`
  },
  {
    question: msg`Does using the platform require technical knowledge?`,
    answer: msg`No. ${AppInfo.APP_NAME} is designed with a user-friendly interface, making it easy to use for beginners. You don’t need to know anything about blockchain or technical details to smoothly use the main features.`
  },
  {
    question: msg`Can it be used on mobile phones?`,
    answer: msg`Absolutely. The platform supports multiple devices, optimized for both desktop browsers and mobile phones, allowing you to access it anytime, anywhere.`
  },
  {
    question: msg`Who is this platform for?`,
    answer: msg`Anyone interested in new technologies, data security, or wanting better control over their digital assets and data can use ${AppInfo.APP_NAME}.`
  },
  {
    question: msg`Can it connect with other wallets or platforms?`,
    answer: msg`Yes. The platform supports integration with various blockchain wallets, DeFi tools, AI, and other popular Web3 applications, enhancing usability and optimizing the user experience.`
  }
]

export function FAQ(): React.JSX.Element {
  const { i18n } = useLingui()
  return (
    <GridSection>
      <div className='bg-diagonal-lines'>
        <div className='grid grid-cols-1 gap-6 px-4 md:px-6 lg:grid-cols-2 lg:gap-8 bg-background py-20 md:py-24 lg:mx-12 lg:border-x'>
          <div className='min-h-60'>
            <Component
              color='rgba(128, 128, 128, 1)'
              animation={{ scale: 100, speed: 90 }}
              noise={{ opacity: 1, scale: 1.2 }}
              sizing='fill'
            />
          </div>
          {/* <div className='text-center lg:text-left'>
            <h2 className='mb-2.5 text-3xl font-semibold md:text-5xl'>
              {i18n._('Frequently Asked Questions')}
            </h2>
            <p className='mt-6 hidden text-muted-foreground md:block lg:max-w-[75%]'>
              {i18n._('Haven’t found what you need? Try')}{' '}
              <Link
                href={Routes.Contact}
                className='font-normal text-inherit underline hover:text-foreground'
              >
                {i18n._('contacting')}
              </Link>{' '}
              {i18n._('us, we’d be happy to assist you.')}
            </p>
            <Image
              src={SloganIcon}
              alt={i18n._('Icon Slogan')}
              className='mx-auto pt-10 animate-pulse max-sm:hidden max-h-[350px]'
              width={400}
              height={400}
            />
          </div> */}
          <div className='mx-auto flex w-full max-w-xl flex-col'>
            <Accordion type='single' collapsible>
              {DATA.map((faq, index) => (
                <AccordionItem key={index} value={index.toString()}>
                  <AccordionTrigger className='text-left text-base'>
                    {i18n._(faq.question)}
                  </AccordionTrigger>
                  <AccordionContent className='text-base'>{i18n._(faq.answer)}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </GridSection>
  )
}
